<template>
  <Card class="form-stepper-card sm:mt-16 box-shadow-none sm:box-shadow-sm sm:p-24">
    <h1 class="text-h2 centered mt-16 mb-16">What type of care do you currently need?</h1>
    <p class="text-body centered mb-24">Guided care type selection coming soon.</p>
  </Card>
</template>

<script lang="ts">
import { PropType } from 'vue';
import Card from '@/components/card/Card.vue';
import { CorporateOnboardingGuidedDraft } from './types';

export default {
  name: 'CorporateOnboardingGuidedCareType',
  components: { Card },
  props: {
    draft: {
      type: Object as PropType<CorporateOnboardingGuidedDraft>,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
.form-stepper-card {
  @media (max-width: 480px) {
    background-color: #fbfbfb !important;
  }
}
</style>
